var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMalawi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.55 69.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M30.41 46.35c-1.09-1.93-4.88-9.89-6.73-10.28-2.24-.54-2.4-1.62-2.32-3.79s-4.19-2.53-4.58-4.62c-.46-2.39.55-3.25 1.71-5.18.38-.62.15-1.7.77-2.09.85-.38 1.78-.07 2.63-.15V20a1.36 1.36 0 0 0-.31-.93 12 12 0 0 0-1.47-1.31c-1.39-1.55.72-3 1-4.89.16-.93-2-1.45-2.11-2.38 0-1.07 0-2.08-.13-3.16-.23-2.32-2.32-4-3.79-5.65-1.54-.92-.62 2-1.85 1.24-1-.62-1.7 0-2.78 0-.78 0-.09-.46-1.09-.54L7.58 2c0 .39-.45.18-.38.26.16.61-1 1.2-.16.58.78-.49 1.16.67 1.32 1.16.39.93 1.08.69.62 1.93s-.24.8.54 1.34S7.42 7.7 8 8.39s.85.93.38 1.7 1.49 2.88.71 3-1.78.23-1.39 1.39c.39.93 1.08 1.55.54 2.63-.38.7-1.39 1.62-1.08 2.47a4.46 4.46 0 0 1 .5 2.42 12.2 12.2 0 0 0-.39 3.32c.08.7-2.32 0-1.47-.12 1.24-.15-.46 1.55-.85 1.7-.85.39-2.86.46-3.32 1.55a4.06 4.06 0 0 0 0 1.93c.15 1 1.78 6.08 1.24 6.54s-1 .54-1.32 1 .85.46.93.77-.31.46-.23.77.46.23.62.39c.46.39.54 1.08.85 1.62.38.7.69 0 1.16-.23s.77.39.31.7l.54-.16c1.08.93 1.16 2.55 2.09 3.64.07-1.09.77.61.92.92.39.93 4.64-.77 5.88-.85 1.55-.07 1.93 1.86 2 3.1.31 2.32.31 4.17-1 6.1-.46.62-.3 1.47-.77 2.09s-1.39.93-1.39 1.78 0 4 .08 5c.08 1.16 2 2.57 3.8 3.42 1.93 1 1-.14 2.79.63s1.83-.45 1.29-1.38c-.62-1.16-.92-1.16 0-2.32.54-.61.31-1.54.85-2.16 1.16-1.39 6.51-.87 7.36-2.88s.62-4.33.62-6.26a4.1 4.1 0 0 1 .75-2.85 5.7 5.7 0 0 0-.59-3.41",
    "data-name": "Layer 93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalawi);
export default __webpack_public_path__ + "static/media/malawi.a40370a6b5252819b0f6c2bbaf706b90.svg";
export { ForwardRef as ReactComponent };